module.exports = __webpack_public_path__ + "media/images/vp/icon.download2.red-2f0fd86d34c325f7bbcb7e8ea517c646.svg";